import React from 'react';
import { motion } from 'framer-motion';

const Section = ({ title, children }) => {
    return (
        <motion.section
            className="section"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, ease: 'easeOut' }}
        >
            <p className="section-title">{title}</p>
            {children}
        </motion.section>
    );
};

export default Section;
